import React, { PureComponent } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'
import ModalReactOverlay from 'react-overlays/Modal'

class Modal extends PureComponent {
  render () {
    const renderBackdrop = (props) => <div className={'giata-modal-backdrop'} {...props} />
    return (
      <ModalReactOverlay show={this.props.show}
                         renderBackdrop={renderBackdrop}
                         onEscapeKeyDown={this.props.onEscapeKeyDown}
                         onBackdropClick={this.props.onBackdropClick}
                         onClick={(e) => {e.stopPropagation()}}
                         className={'giata-modal'}>
        {this.props.children}
      </ModalReactOverlay>
    )
  }
}

Modal.defaultProps = {
  onBackdropClick: (e) => {
    e.preventDefault()
    e.stopPropagation()
  },
  onEscapeKeyDown: (e) => {
    e.preventDefault()
  }
}

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  onBackdropClick: PropTypes.func,
  onEscapeKeyDown: PropTypes.func,
}
export default Modal
